// extracted by mini-css-extract-plugin
export default {"header":"style_header__EXbUg","logo":"style_logo__iVLm2","logoImg":"style_logoImg__BCPB8","ul":"style_ul__O53j2","li":"style_li__qDCD6"};